// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PCaretLeftOutlinedSvg from "@fishx/icons-svg/es/asn/PCaretLeftOutlined";
import FishxIcon from '../components/FishxIcon';

var PCaretLeftOutlined = function PCaretLeftOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PCaretLeftOutlinedSvg
  }));
};

PCaretLeftOutlined.displayName = 'PCaretLeftOutlined';
export default React.forwardRef(PCaretLeftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PCaretLeftOutlined.js
// module id = 3265
// module chunks = 0